import React from "react";
import "../styles/BrandLogo.css";

const prepRightIcon = `${process.env.PUBLIC_URL || ""}/prepright-icon.svg`;

const BrandLogo = ({ className = "", size = "medium" }) => (
  <img
    src={prepRightIcon}
    alt="PrepRight"
    className={`brand-logo brand-logo--${size} ${className}`.trim()}
  />
);

export default BrandLogo;
